import {Link} from 'react-router-dom'

import './Header.css'
import logo from '../../assets/images/logo.png'
import NavItem , {NavItemDropDown} from '../../components/navitem/NavItem'
const Header = (props) => {
  return (
    <div class="navbar navbar-expand-md bg-dark navbar-dark text-white ">
        <div class="container">
            
            <img src={logo}/> 
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mainmenu">
                <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="mainmenu">
                <ul className='navbar-nav ms-auto'> 
                  
                   <NavItem>
                    <Link to ='/'  className='nav-link'>Home</Link>
                </NavItem>
                <NavItem>
                <Link to ='/profile'  className='nav-link'>profile</Link>
                </NavItem>    
                <NavItem>
                    <a className='nav-link'>browse</a>
                </NavItem>
                <NavItemDropDown>
                <a href="#" className="nav-link dropdown-toggle" data-bs-toggle="dropdown">Learn</a>
                        <ul className="dropdown-menu">
                            <li><a href="#learn" className="dropdown-item">Learn Bootstrap</a></li>
                            <li><a href="#next" className="dropdown-item">Where to go next</a></li>   </ul>
                </NavItemDropDown>
                   
                      
                     
                   
                <NavItem>
                    <a className='nav-link'>streams</a>
                </NavItem>

               
                </ul>
            </div>
        </div>
    </div>
  )
}

export default Header